function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6A230"
    },
    cx: 256,
    cy: 256,
    r: 248.396
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M256,512c-68.38,0-132.668-26.629-181.019-74.981C26.629,388.667,0,324.38,0,256 S26.629,123.332,74.981,74.981C123.332,26.629,187.62,0,256,0s132.667,26.629,181.019,74.981C485.371,123.332,512,187.62,512,256 s-26.629,132.667-74.981,181.019S324.38,512,256,512z M256,15.208c-64.318,0-124.786,25.046-170.266,70.527 C40.254,131.214,15.208,191.682,15.208,256s25.046,124.786,70.527,170.266c45.479,45.48,105.946,70.526,170.265,70.526 s124.786-25.046,170.266-70.527c45.48-45.479,70.526-105.947,70.526-170.265s-25.046-124.786-70.527-170.266 C380.786,40.254,320.318,15.208,256,15.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M411.925,411.925l-10.755-10.752c23.197-23.198,40.043-50.708,50.072-81.765l14.471,4.673 C454.939,357.452,436.841,387.008,411.925,411.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M471.177,303.952l-14.85-3.285c15.278-69.058-5.341-140.026-55.156-189.841l10.754-10.754 c26.647,26.648,46.098,59.841,56.246,95.99C478.004,231.085,479.043,268.393,471.177,303.952z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 256,
    cy: 256,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M256,279.917c-13.188,0-23.917-10.729-23.917-23.917c0-13.188,10.729-23.917,23.917-23.917 c13.188,0,23.917,10.729,23.917,23.917C279.917,269.188,269.188,279.917,256,279.917z M256,247.291 c-4.802,0-8.709,3.907-8.709,8.709s3.907,8.709,8.709,8.709s8.709-3.907,8.709-8.709S260.802,247.291,256,247.291z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 126.368,
    cy: 256,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M126.371,279.917c-13.188,0-23.917-10.729-23.917-23.917c0-13.188,10.729-23.917,23.917-23.917 s23.917,10.729,23.917,23.917C150.287,269.188,139.558,279.917,126.371,279.917z M126.371,247.291c-4.802,0-8.709,3.907-8.709,8.709 s3.907,8.709,8.709,8.709c4.802,0,8.709-3.907,8.709-8.709S131.172,247.291,126.371,247.291z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 320.816,
    cy: 126.368,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M320.815,150.287c-13.188,0-23.917-10.729-23.917-23.917s10.729-23.917,23.917-23.917 c13.188,0,23.917,10.729,23.917,23.917S334.002,150.287,320.815,150.287z M320.815,117.662c-4.802,0-8.709,3.907-8.709,8.709 c0,4.802,3.907,8.709,8.709,8.709c4.802,0,8.709-3.907,8.709-8.709C329.524,121.568,325.617,117.662,320.815,117.662z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 385.632,
    cy: 256,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M385.629,279.917c-13.188,0-23.917-10.729-23.917-23.917c0-13.188,10.729-23.917,23.917-23.917 c13.188,0,23.917,10.729,23.917,23.917C409.546,269.188,398.818,279.917,385.629,279.917z M385.629,247.291 c-4.802,0-8.709,3.907-8.709,8.709s3.906,8.709,8.709,8.709c4.802,0,8.709-3.907,8.709-8.709S390.432,247.291,385.629,247.291z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 191.184,
    cy: 126.368,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M191.185,150.287c-13.188,0-23.917-10.729-23.917-23.917s10.729-23.917,23.917-23.917 s23.917,10.729,23.917,23.917S204.373,150.287,191.185,150.287z M191.185,117.662c-4.802,0-8.709,3.907-8.709,8.709 c0,4.802,3.907,8.709,8.709,8.709s8.709-3.907,8.709-8.709C199.894,121.568,195.988,117.662,191.185,117.662z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 320.816,
    cy: 385.632,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M320.815,409.546c-13.188,0-23.917-10.729-23.917-23.917c0-13.188,10.729-23.917,23.917-23.917 c13.188,0,23.917,10.729,23.917,23.917C344.732,398.818,334.002,409.546,320.815,409.546z M320.815,376.921 c-4.802,0-8.709,3.906-8.709,8.709c0,4.802,3.907,8.709,8.709,8.709c4.802,0,8.709-3.906,8.709-8.709 C329.524,380.828,325.617,376.921,320.815,376.921z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C66500"
    },
    cx: 191.184,
    cy: 385.632,
    r: 16.313
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53180F"
    },
    d: "M191.185,409.546c-13.188,0-23.917-10.729-23.917-23.917c0-13.188,10.729-23.917,23.917-23.917 s23.917,10.729,23.917,23.917C215.102,398.818,204.373,409.546,191.185,409.546z M191.185,376.921c-4.802,0-8.709,3.906-8.709,8.709 c0,4.802,3.907,8.709,8.709,8.709s8.709-3.906,8.709-8.709C199.894,380.828,195.988,376.921,191.185,376.921z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.6a7613ff57dceecc1996e6b9fe5e14bb.svg";
export { ForwardRef as ReactComponent };